(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(' .collection-faq  .faq-detail').forEach(item => {
  item.addEventListener('toggle', e => {
    const icon = item.querySelector('.collection-faq  .faq-icon');
    if (item.open) {
      icon.textContent = '-';
    } else {
      icon.textContent = '+';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }

            const section = document.querySelector(
              '#shopify-section-template--31198794580254__product-recommendations'
            );

            if (!section) return;

            const slider = section.querySelector(
              '.product-grid-border-fix.fix-borders-split'
            );

            const prevButton = section.querySelector('.recommendation-prev');
            const nextButton = section.querySelector('.recommendation-next');

            if (!slider || !prevButton || !nextButton) return;

            function getScrollAmount() {
              const product = slider.querySelector('.site-box');

              if (!product) {
                return slider.clientWidth * 0.8;
              }

              const productWidth = product.getBoundingClientRect().width;
              const gap = parseFloat(getComputedStyle(product).marginLeft) +
                          parseFloat(getComputedStyle(product).marginRight);

              return productWidth + gap;
            }

            

            function updateButtons() {
              const maxScroll = slider.scrollWidth - slider.clientWidth;
               prevButton.disabled = slider.scrollLeft <= 5;
                nextButton.disabled = slider.scrollLeft >= maxScroll - 5;
            }

            nextButton.addEventListener('click', function () {
              slider.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
              });
            });

            prevButton.addEventListener('click', function () {
              slider.scrollBy({
                left: -getScrollAmount(),
                behavior: 'smooth'
              });
            });

            slider.addEventListener('scroll', updateButtons);
            window.addEventListener('resize', updateButtons);
            updateButtons();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
